export default __webpack_public_path__ + "static/staff-photo-3-823b1019c71391e4df55779e322533c1.jpg";